import React, { Fragment, Component } from "react";
import NavBar from "../../common/forms/NavbarCopy";
import { Row, Col, Container} from "react-bootstrap";
import { AddNotification } from "../../Methods/Notificaition.jsx";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import { subDirectory } from "../../../config.json";
import "../../../styles/BoardingPassList.scss";
import { generateBordingPass, generateBordingPassNext, getDownloadReceipt } from "../../../services/bordingPassService";
import logo from "../../../images/logopng.png";
import ttdc_tlogo from "../../../images/ttdc_tlogo.png";
import { SkReceiptCard } from "../../common/skeleton/subcatCardSkeleton";
import moment from "moment";
import { BsDownload } from "react-icons/bs";
import { MdPrint } from "react-icons/md";
import { QRCode } from "react-qr-code";




class BoardingPassTicket extends Component {
  constructor(props) {
    super(props);

    this.state = {
      BoatHouseId: "",
      BookingId: "",
      BoardingPassDetails: [],
      isReceiptLoading: true,
      base64Image: null,
      conversionError: null,
     
    };
  }
 
  componentDidMount = async () => {
    if (this.props.location?.state) {
      await this.setState({
        ActualBoatNum: this.props.location?.state?.bookings.ActualBoatNum,
        ActualBoatId: this.props.location?.state?.bookings.ActualBoatId,
        ExpectedTime: this.props.location?.state?.bookings.ExpectedTime,
        BoatHouseId: this.props.location?.state?.BoatHouseId,
        BookingId: this.props.location?.state?.BookingId,
      });
    }
    await this.fetchImage();
    await this.boardingpass();
    await this.setState({ isReceiptLoading: false });

  };
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  fetchImage = async () => {
    try {
      const base64 = await this.imageUrlToBase64(logo);
      this.setState({ base64Image: base64 })
    } catch (error) {
      this.setState({ conversionError: error.message || 'Error converting image' })
    }
  }

  imageUrlToBase64 = async (url) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error('Error fetching or converting image:', error);
      throw error;
    }
  };




  printContent = async () => {
    var printStyle = `<style>


    @media print {
      body * {
        font-family: Roboto !important;
      }
    } 
 

    .bpdiv{
      display:flex !important;
      justify-content:space-around !important; 
      padding:1rem 0rem
    }    


     
    .bbt{
      font-size:14px !important 
    }
    .bbt-d{
      font-size:10px !important
    }
    .bbt-n{
      font-size:12px !important
    }


    .onpayment1{
      padding:0.5rem 0rem
    }
    .r-details{
      line-height:1.5; 
      font-size:14px !important
    }

    </style>`
    var content = document.getElementById('Pdfbodydownload');
    if (content) {
      var pri = document.getElementById("ifmcontentstoprint").contentWindow;
      // pri+=htmlToPrint;
      pri.document.open();
      pri.document.write(printStyle);
      pri.document.write(content.innerHTML);
      pri.document.close();
      pri.focus();
      pri.print();
      return true
    }
  }




 
  downloadContent = async () => {
    try {
      let data = {
        BookingId: this.state.BookingId,
        BoatHouseId: this.state.BoatHouseId,
        BookingType: "B",
      };
      await getDownloadReceipt(data);
    } catch (error) {
      console.error('Error converting HTML to PDF:', error);
    }
  };

  boardingpass = async () => {
    if (this.state.ActualBoatNum === null && this.state.ExpectedTime === null && this.state.ActualBoatId === null) {

      let data = {
        BoatHouseId: this.state.BoatHouseId,
        BookingId: this.state.BookingId,
      };
      const res = await generateBordingPassNext(data);
      if (res.data.StatusCode === 1) {
        let data1 = {
          BoatHouseId: this.state.BoatHouseId,
          BookingId: this.state.BookingId,
        };
        const res1 = await generateBordingPass(data1);
        if (res1.data.StatusCode === 1) {
          this.setState({ BoardingPassDetails: res1.data.Response });
        } else {
          this.setState({ BoardingPassDetails: [] });
        }
        // this.setState({ BoardingPassDetails: res.data.Response });
      }
    }
    else {
      let data2 = {
        BoatHouseId: this.state.BoatHouseId,
        BookingId: this.state.BookingId,
      };
      const res2 = await generateBordingPass(data2);
      console.log(res2)
      if (res2.data.StatusCode === 1) {
        this.setState({ BoardingPassDetails: res2.data.Response });
      } else {
        this.setState({ BoardingPassDetails: [] });
      }
    }
  };

  render() {
    const { base64Image, conversionError } = this.state;

    return (
      <div>

        <Fragment>
          <AddNotification visible={this.state.openNotification} variant={this.state.variant} message={this.state.message} onClose={() => this.setState({ openNotification: false })} />
          {/* <Loader fullPage loading={this.state.loading} /> */}
          <NavBar {...this.props} />
          <div className="boarding-pass-receipt">
            <div class="hotelReceipt ">
              <div className="d-flex boarding-pass-Receipt-wrapper">
                {
                  <Container fluid className="hotelReceipt-con py-2">
                    <div className="initialpage">
                      <div
                        onClick={() => {
                          this.props.history.push(`${subDirectory}/boatBookingHistory`);
                        }} style={{ cursor: "pointer" }}
                      >
                        <BsArrowLeft className="mr-2" /> Go to Booking History
                      </div>

                      <div
                        onClick={() => {
                          this.props.history.push(`${subDirectory}/boardingPass`);
                        }} style={{ cursor: "pointer" }}
                      >
                        Go to Boarding Pass <BsArrowRight className="ml-2" />
                      </div>
                      <div className="initialprint">
                        <div onClick={this.downloadContent}>
                          <BsDownload size={30} style={{ cursor: "pointer", color: "white" }} />
                        </div>
                        <div onClick={this.printContent}>
                          <MdPrint size={30} style={{ cursor: "pointer", color: "white" }} />
                        </div>
                      </div>
                    </div>

                    <div class="receipt" id="Pdfbodydownload">
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: "center", flexWrap: 'wrap', columnGap: '15rem' }} className="receipt-header">
                        <div  >
                          {base64Image ? (
                            <div>
                              <img
                                id="base64ImageId"
                                src={base64Image}
                                alt="logo"
                                class="logo"
                                onError={(e) => console.error('Image error:', e)}
                              />
                            </div>

                          ) : null}
                        </div>
                        <div >
                          <div>
                            <div class="hotelbooking">Boat Boarding Pass</div>
                          </div>
                        </div>
                      </div>
                      {this.state.isReceiptLoading && <SkReceiptCard />}

                      {!this.state.isReceiptLoading && (
                        <>
                          {this.state.BoardingPassDetails.map((details, j) => (
                            <>
                              <div className="bpdiv" style={{ display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap', rowGap: '0.1rem', alignItems: 'center' }}>
                                <div >
                                  <div style={{ position: 'relative' }}>
                                    <QRCode value={`${details.BoatHouseId};${details.BookingId};${details.BoatReferenceNo};${details.BookingPin}`} size="110" />,{/* <img src={boatqr} alt="qrcode" className="qrdiv" /> */}

                                    <div style={{ position: 'absolute', bottom: '45px', left: '45px' }}>
                                      <img src={ttdc_tlogo} width={20} />
                                    </div>

                                  </div>
                                </div>

                                <div className=" ">
                                  <div style={{ fontSize: ' clamp(1rem, 2.5vw, 1.5rem)', fontWeight: '400', textAlign: 'center' }} className="bbt"  >Boarding Pass</div>
                                  <div style={{ fontSize: ' clamp(1rem, 2.5vw, 1.2rem)', fontWeight: '400', textAlign: 'center' }} className="bbt-d" >{details.BookingDate}</div>


                                  <div className="bbt-n" style={{ fontSize: ' clamp(1rem, 2.5vw, 1.5rem)', fontWeight: '400', textAlign: 'center' }}>{details.BoatHouseName}</div>
                                </div>

                              </div>

                              <Row className="rr-1">
                                <Col lg={12} md={12} sm={12} xs={12} className="inlinerec my-1">
                                  <div className="onpayment1">
                                    <div>
                                      <div class="r-details">Booking Id : {details.BookingId}</div>
                                      <div class="r-details">Booked Date : {details.BookedDate ? details.BookedDate : new Date().toLocaleDateString('en-GB')}</div>
                                      <div class="r-details">
                                        Booked Boat : {details.BoatType}-{details.SeaterType}
                                      </div>
                                      <div class="r-details">Booking Type: {details.PremiumStatus}</div>
                                      <div class="r-details">Duration : {details.BookingDuration}(Mins)</div>
                                    </div>
                                  </div>
                                  <div>
                                    <div className="receiptid">
                                      {/* <div className="receiptid"><h5 class="r-details">Booking Type:{i.PremiumStatus} </h5> */}
                                      <div class="r-details rpin"> PIN : {details.BookingPin}</div>
                                      <div class="r-details">Time slot : {moment(details.SlotTime.split("-")[0], "hh").format('LT')}</div>





                                      {/* <h5 class="r-details">BoardingTime : {details.BoardingTime}</h5> */}



                                      <div class="r-details">Boat Number : {details.ActualBoatNum}</div>

                                      <div class="r-details rpin">Amount : ₹ {details.InitNetAmount}</div>
                                      {/* <div class="r-info">{i.CustomerMobile}</div> */}
                                    </div>
                                  </div>
                                </Col>
                                <hr className="hr1" />
                              </Row>
                            </>
                          ))}
                        </>
                      )}
                    </div>
                   
                  </Container>
                }
              </div>
            </div>
          </div>
        </Fragment>
      </div>
    );
  }
}

export default BoardingPassTicket;
